export enum Role {
    Undefined = 0,
    Employee = 10,
    Leader = 20,
    Manager = 30
}